import React, { useMemo } from 'react';
import { sanitizeEmailHtml } from '../../utils/emailSanitizer'; // inboxxss-7c4f2a91

const EmailContentDisplay = ({ email }) => {
    // inboxxss-7c4f2a91 — EVERY HTML body is sanitized here, at the one place it is rendered,
    // for both providers (Microsoft used to arrive raw; Gmail only had a weak regex). Never
    // render email.body as HTML anywhere else.
    const safeHtml = useMemo(
        () => (email?.isHtml ? sanitizeEmailHtml(email.body) : ''),
        [email?.isHtml, email?.body]
    );

    if (!email) return null;

    if (email.isHtml) {
        return (
            <div
                className="prose max-w-none"
                dangerouslySetInnerHTML={{ __html: safeHtml }}
                style={{
                    wordBreak: 'break-word',
                    overflowWrap: 'break-word',
                    // inboxxss-7c4f2a91 — a position:fixed inline style inside the email is
                    // contained by this box instead of covering the CRM page.
                    contain: 'content',
                    overflow: 'hidden',
                }}
            />
        );
    } else {
        return (
            <div
                className="whitespace-pre-wrap"
                style={{
                    wordBreak: 'break-word',
                    overflowWrap: 'break-word',
                    fontFamily: 'inherit'
                }}
            >
                {email.body}
            </div>
        );
    }
};

export default EmailContentDisplay;
